import './animations.css';
import type { WeatherSnapshot } from '@/types/weather';
import { getSceneConfig } from './sceneConfig';
import { SkyLayer } from './layers/SkyLayer';
import { StarsLayer } from './layers/StarsLayer';
import { FarCloudsLayer } from './layers/FarCloudsLayer';
import { SunMoonLayer } from './layers/SunMoonLayer';
import { FogLayer } from './layers/FogLayer';
import { NearCloudsLayer } from './layers/NearCloudsLayer';
import { PrecipitationLayer } from './layers/PrecipitationLayer';
import { LightningLayer } from './layers/LightningLayer';
import { RabbitLayer } from './layers/RabbitLayer';
import { GroundLayer } from './layers/GroundLayer';
import { TextOverlayLayer } from './layers/TextOverlayLayer';

interface Props {
  weather: WeatherSnapshot;
}

export function WeatherSceneView({ weather }: Props) {
  const config = getSceneConfig(weather);

  return (
    <div className="weather-scene">
      <SkyLayer
        config={config}
        lightning={config.lightning}
        lightningFrequency={config.lightningFrequency}
      />
      <StarsLayer visible={config.showStars} />
      <FarCloudsLayer
        cloudDensity={config.cloudDensity}
        cloudStyle={config.cloudStyle}
        windMultiplier={config.windMultiplier}
        driftDirection={config.cloudDriftDirection}
        skyColor={config.skyGradient.top}
      />
      <SunMoonLayer
        sunOpacity={config.sunOpacity}
        moonOpacity={config.moonOpacity}
        skyColor={config.skyGradient.top}
      />
      <FogLayer fog={config.fog} />
      <NearCloudsLayer
        cloudDensity={config.cloudDensity}
        cloudStyle={config.cloudStyle}
        windMultiplier={config.windMultiplier}
        driftDirection={config.cloudDriftDirection}
        skyColor={config.skyGradient.top}
      />
      <PrecipitationLayer
        precipitation={config.precipitation}
        intensity={config.precipitationIntensity}
        rainAngle={config.rainAngle}
      />
      <LightningLayer lightning={config.lightning} frequency={config.lightningFrequency} />
      <GroundLayer
        skyColor={config.skyGradient.bottom}
        precipitation={config.precipitation}
        isNight={!weather.isDay}
      />
      <RabbitLayer precipitation={config.precipitation} skyColor={config.skyGradient.top} />
      <PrecipitationLayer
        precipitation={config.precipitation}
        intensity={config.precipitationIntensity}
        rainAngle={config.rainAngle}
        foreground
      />
      <TextOverlayLayer skyColor={config.skyGradient.top} />
    </div>
  );
}
